module.exports = __webpack_public_path__ + "static/media/vl1.03ba41b5.png";